import o from "../../../helpers/service-helper.js";
import "react/jsx-runtime";
import "dayjs";
const p = async (e) => {
  const t = {
    "Content-Type": "application/json"
  };
  return o.httpDelete(`/v1/rentaltrailer/booking?bookingId=${e}`, {
    headers: t
  });
};
export {
  p as deleteTrailerBookingRequest
};
